export default __webpack_public_path__ + "static/B0029-eadbdc63b2f507723b2673e22b2b1445.png";